export const temple = [
    {
        left: "temple-roof-l",
        middle: ["temple-roof"],
        right: "temple-roof-r",
    },
    {
        left: "temple-balcony-l",
        middle: ["temple-body"],
        right: "temple-balcony-r",
    },
    {
        left: "temple-body",
        middle: ["temple-body"],
        right: "temple-body",
    },
    {
        left: "temple-body",
        middle: ["temple-body"],
        right: "temple-body",
    },
    {
        left: "temple-body",
        middle: ["temple-body"],
        right: "temple-body",
    },
];

export const templeInverted = [
    {
        left: "temple-balcony-l",
        middle: ["temple-body"],
        right: "temple-balcony-r",
    },
    {
        left: "temple-body",
        middle: ["temple-body"],
        right: "temple-body",
    },
    {
        left: "temple-body",
        middle: ["temple-body"],
        right: "temple-body",
    },
    {
        left: "temple-balcony-l",
        middle: ["temple-body"],
        right: "temple-balcony-r",
    },
    {
        left: "temple-body",
        middle: ["temple-body"],
        right: "temple-body",
    },
];

export const grass = [
    {
        left: "platform-l",
        middle: ["platform-body"],
        right: "platform-r",
        offset: { x: 0, y: 3 },
        dimensions: { width: 32, height: 18 },
    },
];

export const lanterns = [
    {
        left: {
            sprite: "lantern-l",
            offset: { x: 0, y: -15 },
        },
        middle: ["lantern-body"],
        right: {
            sprite: "lantern-r",
            offset: { x: 0, y: -15 },
        },
        offset: { x: 0, y: -14 },
        dimensions: { width: 32, height: 32 },
    },
];

export const spikes = [
    {
        left: "spike-l",
        middle: ["spike-body"],
        right: "spike-r",
    }
];

export const shrine1 = [
    {
        left: "shrine-top-l-1",
        middle: ["shrine-top-l-2", "shrine-top-r-2"],
        right: "shrine-top-r-1",
        offset: { x: 0, y: 3 },
        dimensions: { width: 32, height: 22 },
    },
    {
        left: "blank",
        middle: ["shrine-leg-l", "shrine-leg-r"],
        right: "blank",
    }
];

export const shrine2 = [
    {
        left: "shrine-top-l-1",
        middle: ["shrine-top-l-4", "shrine-top-r-4"],
        right: "shrine-top-r-1",
        offset: { x: 0, y: 3 },
        dimensions: { width: 32, height: 22 },
    },
    {
        left: "blank",
        middle: ["shrine-leg-l", "shrine-leg-r"],
        right: "blank",
    }
];

export default {
    "test": temple,
    "temple": temple,
    "templeInverted": templeInverted,
    "grass": grass,
    "lanterns": lanterns,
    "spikes": spikes,
    "shrine1": shrine1,
    "shrine2": shrine2,
};



// WEBPACK FOOTER //
// ./src/assets.ts